module.exports = __webpack_public_path__ + "static/media/iconAt.737fcb16.svg";